import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AclNgxModule } from '@amobee/acl-ngx';
import { ReactComponentsModule } from '../../react-components/react-components.module';
import { DataTableComponent } from './data-table.component';
import { ToolbarInputComponent } from './toolbar-input/toolbar-input.component';
import { ListFilterComponent } from './list-filter/list-filter.component';
import { ListFilterSelectedComponent } from './list-filter-selected/list-filter-selected.component'
import { AutoCompleteModule } from '../auto-complete/auto-complete.module';
import { TableToolbarWrapperComponent } from './table-toolbar-wrapper/table-toolbar-wrapper.component';
import { TableToolbarButtonWrapperComponent } from './table-toolbar-button-wrapper/table-toolbar-button-wrapper.component';

@NgModule({
    declarations: [
        DataTableComponent,
        ToolbarInputComponent,
        ListFilterComponent,
        ListFilterSelectedComponent,
        TableToolbarWrapperComponent,
        TableToolbarButtonWrapperComponent
    ],
    imports: [CommonModule, AclNgxModule, ReactiveFormsModule, ReactComponentsModule, AutoCompleteModule],
    exports: [DataTableComponent, ListFilterComponent, ListFilterSelectedComponent]
})
export class DataTableModule { }